import apiClient from './api'
import type { PaginatedResponse } from '../types'
import type {
  Device,
  DeviceToken,
  BindDeviceRequest,
  BindDeviceResponse,
  UpdateDeviceRequest,
  RegenerateTokenResponse,
  ChannelConfig,
  UpdateChannelConfigRequest,
} from '../types/device'

export const deviceService = {
  bindDevice: async (data: BindDeviceRequest): Promise<BindDeviceResponse> => {
    const response = await apiClient.post<{ data: BindDeviceResponse; message: string }>('/devices/bind', data)
    return response.data.data
  },

  listDevices: async (page = 1, pageSize = 10): Promise<PaginatedResponse<Device>> => {
    const response = await apiClient.get<PaginatedResponse<Device>>('/devices', { params: { page, page_size: pageSize } })
    return response.data
  },

  getDevice: async (id: number): Promise<Device> => {
    const response = await apiClient.get<{ data: Device }>(`/devices/${id}`)
    return response.data.data
  },

  updateDevice: async (id: number, data: UpdateDeviceRequest): Promise<Device> => {
    const response = await apiClient.put<{ data: Device }>(`/devices/${id}`, data)
    return response.data.data
  },

  unbindDevice: async (id: number): Promise<void> => {
    await apiClient.delete(`/devices/${id}`)
  },

  regenerateToken: async (id: number): Promise<RegenerateTokenResponse> => {
    const response = await apiClient.post<{ data: RegenerateTokenResponse; message: string }>(`/devices/${id}/regenerate`)
    return response.data.data
  },

  listTokens: async (id: number): Promise<DeviceToken[]> => {
    const response = await apiClient.get<{ data: DeviceToken[] }>(`/devices/${id}/tokens`)
    return response.data.data
  },

  listChannelConfigs: async (id: number): Promise<ChannelConfig[]> => {
    const response = await apiClient.get<{ data: ChannelConfig[] }>(`/devices/${id}/channels`)
    return response.data.data
  },

  updateChannelConfig: async (deviceId: number, channelType: string, data: UpdateChannelConfigRequest): Promise<ChannelConfig> => {
    const response = await apiClient.put<{ data: ChannelConfig }>(`/devices/${deviceId}/channels/${channelType}`, data)
    return response.data.data
  },

  deleteChannelConfig: async (deviceId: number, channelType: string): Promise<void> => {
    await apiClient.delete(`/devices/${deviceId}/channels/${channelType}`)
  },
}

export default deviceService
